import { Form, AutoComplete } from 'antd';
import React from 'react';

const AutoCompleteUC = (props) => {
    const {
        name,
        label,
        isCustomError = false,
        labelError = null,
        showLabel = true,
        type = "text",
        onChange,
        values,
        // maxLength,
        suffix,
        required,
        disabled,
        hidden,
        mask,
        placeholder = 'กรุณาเลือก' + label,
        showPlaceholder = true,
        options,
        ...prop } = props;
    return (
        <>
            <Form.Item
                name={name}
                label={showLabel ? (label + ' :') : ''}
                rules={required ? [{
                    required: true,
                    message: 'กรุณาเลือก ' + label
                }, {
                    validator: (_, value) =>
                        (typeof (name) === 'string' && name.toString().toLowerCase().includes("code")) ? (
                            !value || !value.toString().includes(' ')
                                ? Promise.resolve()
                                : Promise.reject(new Error(label + ' ไม่สามารถมีช่องว่าง'))
                        ) : Promise.resolve()
                }] : ''
                }
                validateStatus={(isCustomError && required) ? 'error' : undefined}
                help={(isCustomError && required) ? labelError : null}
                initialValue={values ? values : ''}
            >
                <AutoComplete
                    {...prop}
                    className={'auto-complete-rc'}
                    mask={mask}
                    type={type}
                    disabled={disabled}
                    onChange={onChange}
                    placeholder={showPlaceholder ? placeholder : ''}
                    options={options}
                    filterOption={(inputValue, option) =>
                        option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                    }
                />
            </Form.Item>
        </>

    )
}
export default AutoCompleteUC;